import { User } from '@/modules/user/models/User';
import { PredefinedUserRole } from '/@/modules/role/enums/PredefinedUserRole';

export const ClearBotUser: Partial<User> = {
  email: 'clearbot@clearestate.com',
  roleId: PredefinedUserRole.SUPER_ADMIN.id,
  active: true,
  isDemo: false,
  avatarUrl: 'https://app.clearestate.com/favicon.png',
  contact: {
    firstName: 'ClearBot',
    email: 'clearbot@clearestate.com'
  }
};
